import {useEffect,useRef,useState} from 'react';
import type {FolderLocation} from './explorerApi';
import {folderHelperStatus,isWindows} from './folderMode';
import {NativeEntryError,openNativeEntry} from './nativeEntryOpen';

export function useNativeEntryOpen(enabled:boolean,notify:(message:string)=>void) {
  const pending=useRef<AbortController|null>(null);
  const [needsUpdate,setNeedsUpdate]=useState(false);
  useEffect(()=>{
    if(!enabled||!isWindows())return;
    const check=()=>{void folderHelperStatus();};check();const timer=setInterval(check,5000);
    return()=>{clearInterval(timer);pending.current?.abort();};
  },[enabled]);
  const open=async(location:FolderLocation)=>{
    pending.current?.abort();const controller=new AbortController();pending.current=controller;
    setNeedsUpdate(false);notify('Проверяем доступ с вашего компьютера…');
    try {await openNativeEntry(location,controller.signal);if(!controller.signal.aborted)notify('');}
    catch(error){if(!controller.signal.aborted){setNeedsUpdate(error instanceof NativeEntryError&&error.update);notify(error instanceof Error?error.message:'Не удалось открыть Проводник.');}}
  };
  return {open,needsUpdate};
}
